import {
  CardViewBaseItemModel,
  CardViewUpdateService,
  UpdateNotification,
} from '@alfresco/adf-core';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkCardViewUpdateService {
  get itemUpdated$(): Subject<UpdateNotification> {
    return this.cardViewUpdateService.itemUpdated$;
  }
  constructor(private readonly cardViewUpdateService: CardViewUpdateService) {}

  updateElement(element: CardViewBaseItemModel): void {
    return this.cardViewUpdateService.updateElement(element);
  }

  update(property: CardViewBaseItemModel, newValue: any) {
    return this.cardViewUpdateService.update(property, newValue);
  }
}
